<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">{{'copyright' | translate}} {{ today | date:'y'}} © QUIDAK {{'by' | translate}} Better Planning  </p>
    </div>
  </div>
</div>
